import { useEffect, useRef, useState } from "react";
import s from "./CardCarousel.module.scss";
import TourCard from "../../../components/TourCard/TourCard";
import TourCardIndividual from "../../../components/TourCard/TourCardIndividual";



const CardCarousel = ({tours}) => {
    const containerRef = useRef();
    const [itemsPerView, setItemsPerView] = useState(4);
    const [index, setIndex] = useState(
        tours.length > itemsPerView ? itemsPerView : 0
    );
    const [isDragging, setIsDragging] = useState(false);
    const startXRef = useRef(0);
    const movedRef = useRef(false);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 576) {
                setItemsPerView(1);   // mobile
            } else if (window.innerWidth < 992) {
                setItemsPerView(2);   // tablet
            } else if (window.innerWidth < 1200) {
                setItemsPerView(3);   // small desktop
            } else {
                setItemsPerView(4);   // large desktop
            }
        };

        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);
    useEffect(() => {
        setIndex(tours.length > itemsPerView ? itemsPerView : 0);
    }, [itemsPerView, tours]);
    // Responsive
    useEffect(() => {
        const total = tours.length;

        if (index === total) {
            setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.style.transition = "none";
                    setIndex(0);

                    // force reflow
                    void containerRef.current.offsetHeight;

                    containerRef.current.style.transition = "transform 0.5s ease";
                }
            }, 500);
        }

        if (index === -1) {
            setTimeout(() => {
                if (containerRef.current) {
                    containerRef.current.style.transition = "none";
                    setIndex(total - 1);

                    void containerRef.current.offsetHeight;

                    containerRef.current.style.transition = "transform 0.5s ease";
                }
            }, 500);
        }
    }, [index]);
    // Clone for infinite loop
    const extended =
        tours.length > itemsPerView
            ? [
                ...tours.slice(-itemsPerView),
                ...tours,
                ...tours.slice(0, itemsPerView),
            ]
            : tours;

    const handleNext = () => setIndex(prev => prev + 1);
    const handlePrev = () => setIndex(prev => prev - 1);

    // Reset loop
    useEffect(() => {
        if (index >= tours.length) {
            setTimeout(() => setIndex(0), 500);
        }
        if (index < 0) {
            setTimeout(() => setIndex(tours.length - 1), 500);
        }
    }, [index]);

    // Drag logic
    let startX = 0;

    const onStart = (e) => {
        setIsDragging(true);
        movedRef.current = false;
        startXRef.current = e.touches ? e.touches[0].clientX : e.clientX;
    };

    const onMove = (e) => {
        if (!isDragging) return;

        const currentX = e.touches ? e.touches[0].clientX : e.clientX;
        const diff = Math.abs(startXRef.current - currentX);

        if (diff > 5) {
            movedRef.current = true; // user actually dragged
        }
    };

    const onEnd = (e) => {
        if (!isDragging) return;
        setIsDragging(false);

        const endX = e.changedTouches ? e.changedTouches[0].clientX : e.clientX;
        const diff = startXRef.current - endX;

        // ❗ IMPORTANT: only swipe if user dragged enough
        if (Math.abs(diff) > 50) {
            diff > 0 ? handleNext() : handlePrev();
        }
    };

    return (
        // <TourCardIndividual item={tours[0]}/>
        <div className={s.carousel}>

            <div
                className={s.inner}
                ref={containerRef}
                style={{
                    transform: `translateX(-${index * (100 / itemsPerView)}%)`,
                    transition: isDragging
                        ? "none"
                        : "transform 0.6s cubic-bezier(0.25, 0.46, 0.45, 0.94)"
                }}
                onMouseDown={onStart}
                onMouseMove={onMove}
                onMouseUp={onEnd}
                onMouseLeave={onEnd}
                onTouchStart={onStart}
                onTouchMove={onMove}
                onTouchEnd={onEnd}
            >
                {extended.map((item, i) => (
                    <div
                        key={i}
                        className={s.item}
                        style={{ flex: `0 0 ${100 / itemsPerView}%` }}
                    >
                        <TourCardIndividual item={item}  onClick={(e) => {
                            if (movedRef.current) {
                                e.preventDefault();
                                e.stopPropagation();
                            }
                        }}/>
                    </div>
                ))}
            </div>

            {/* Buttons */}
            <button className={s.prev} onClick={handlePrev}>‹</button>
            <button className={s.next} onClick={handleNext}>›</button>

        </div>
    );
};

export default CardCarousel;